import { render, staticRenderFns } from "./edit-text.vue?vue&type=template&id=77e610ca&"
import script from "./edit-text.vue?vue&type=script&lang=js&"
export * from "./edit-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports